module.exports = __webpack_public_path__ + "img/LOGO_SONPHAT-New.26658178.png";